import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  listClub: (filters: any[]) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $filters: [Filter]
        ) {
          listClub (
            limit: 999
            filters: $filters
          ) {
            items {
              id
              region {
                id
                title {
                  ru
                  current
                }
              }
              countryPartners {
                id
                title {
                  current
                }
              }
              vkontakte
              telegram
              max
              phone
              email
            }
          }
        }
      `,
      variables: {
        filters,
      },
    }),
  ),
})
